export type FeaturedBadgeColorVariant = 1 | 2 | 3;

export type FeaturedBadgeColorSlug =
  | "closed"
  | "danger"
  | "urgent"
  | "soon"
  | "warning"
  | "notice";

export const FEATURED_BADGE_COLOR_SLUGS: FeaturedBadgeColorSlug[] = [
  "closed",
  "danger",
  "urgent",
  "soon",
  "warning",
  "notice",
];

export function isFeaturedBadgeColorSlug(value: string): value is FeaturedBadgeColorSlug {
  return FEATURED_BADGE_COLOR_SLUGS.includes(value as FeaturedBadgeColorSlug);
}

export interface FeaturedBadgeColorSwatch {
  backgroundColor: string;
  textColor: string;
}
